export const FETCH_PRINT_OPTIONS_BY_TEMPLATE_CODE_REQUEST =
  "API/ENTITIES/PRINT_OPTIONS/FETCH_BY_TEMPLATE_CODE_REQUEST";
export const FETCH_PRINT_OPTIONS_BY_TEMPLATE_CODE_REQUEST_SUCCESS =
  "API/ENTITIES/PRINT_OPTIONS/FETCH_BY_TEMPLATE_CODE_REQUEST_SUCCESS";
export const FETCH_PRINT_OPTIONS_BY_TEMPLATE_CODE_REQUEST_FAILURE =
  "API/ENTITIES/PRINT_OPTIONS/FETCH_BY_TEMPLATE_CODE_REQUEST_FAILURE";
